import React, {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import {setModalPortalGuestHandler} from 'utils'
import {ModalPortalGuestContext} from './ModalPortalGuestContext'
import ModalPortalGuestItem from './ModalPortalGuestItem'

interface ModalPortalGuestProviderProps {
  children: ReactNode
}
export default function ModalPortalGuestProvider({
  children,
}: ModalPortalGuestProviderProps) {
  const [openModal, setOpenModal] = useState(false)

  const handleShowPortalGuestModal = useCallback(() => {
    setOpenModal(true)
  }, [])

  const handleHidePortalGuestModal = useCallback(() => {
    setOpenModal(false)
  }, [])

  const handleRenderModal = useMemo(() => {
    if (!openModal) {
      return
    }

    return <ModalPortalGuestItem onClose={handleHidePortalGuestModal} />
  }, [openModal, handleHidePortalGuestModal])

  const handler = useMemo(
    () => ({
      showModalPortalGuest: handleShowPortalGuestModal,
    }),
    [handleShowPortalGuestModal],
  )

  useEffect(() => {
    setModalPortalGuestHandler(handler)
  }, [handler])

  return (
    <ModalPortalGuestContext.Provider value={handler}>
      {handleRenderModal}
      {children}
    </ModalPortalGuestContext.Provider>
  )
}
